import { render, staticRenderFns } from "./InteriorSpecs.vue?vue&type=template&id=347d2e56&scoped=true&"
import script from "./InteriorSpecs.vue?vue&type=script&lang=js&"
export * from "./InteriorSpecs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "347d2e56",
  null
  
)

export default component.exports